import Parse from '../../app/utils/parse';

export default Parse;
